import React, { Component, Fragment, createRef } from "react";
import AppContext from "../../contexts/AppContext";
import StepsHeader from "./include/StepsHeader";
import CheckoutSteps from "./include/CheckoutSteps";
import { checkToken, updateUserWithToken } from "../../services/user";

export class Preference extends Component {	
    
	constructor(){
        super();
        this.state = {
			loading: false,
			emailPreference: [],
			contactPreference: [],
			item: {},	
			items: {
				user_email_preference: null,
				user_contact_preference: null,
				step: 'preference',				
				token_type: 'pwonbs1'
			},			
			reason : "0",		
			emailSettings : [1,2],
			contactSettings: [],
			errors: {},			
        }

		this.handleEmail = this.handleEmail.bind(this);
		this.handleContact = this.handleContact.bind(this);
    }
	
	whatBrings = Id =>{
		//this.setState({ reason: this.state.reason === Id ? "0" : Id});
	}

	handleEmail = (e) => {
		// current array of options
		const options = this.state.emailSettings
		let index
	
		// check if the check box is checked or unchecked
		if (e.target.checked) {
		  // add the numerical value of the checkbox to options array
		  options.push(+e.target.value)
		} else {
		  // or remove the value from the unchecked checkbox from the array
		  index = options.indexOf(+e.target.value)
		  options.splice(index, 1)
		}
		let temp = this.state.items;
        temp['user_email_preference'] = options.length > 0 ? options.join(',') : null;
		// update the state with the new array of options
		this.setState({ emailSettings: options, items: temp })		
		
	}

	handleContact = (e) => {
		// current array of options
		const options = this.state.contactSettings
		let index
	
		// check if the check box is checked or unchecked
		if (e.target.checked) {
		  // add the numerical value of the checkbox to options array
		  options.push(+e.target.value)
		} else {
		  // or remove the value from the unchecked checkbox from the array
		  index = options.indexOf(+e.target.value)
		  options.splice(index, 1)
		}
		let temp = this.state.items;
        temp['user_contact_preference'] = options.length > 0 ? options.join(',') : null;
		// update the state with the new array of options
		this.setState({ contactSettings: options, items: temp })		
		
	}

	next = () => {
		this.props.history.push('/process/finish/' + this.props.match.params["token"]); 
	}

	handleSubmit = e => { 
		e.preventDefault();
		this.setState({loading: true});
        updateUserWithToken(this.state.items, this.props.match.params["token"])
            .then(res => {
				this.setState({loading: false}); 
				//this.context.state.showCodeMessage(res.message,'success'); 
                if (res.meta.token) {
					this.props.history.push('/process/finish/' + res.meta.token);                    
                }
            })
            .catch(error => {
				this.setState({loading: false}); 				
                this.context.state.handelError(error);
            });    
    }; 

	componentDidMount() {        
        
        checkToken({ token: this.props.match.params["token"], type: 'pwonbs1' })
            .then(res => {
                if (res.status === true) {
                    this.setState({                         
						emailPreference: res.meta.emailPrefernce, 
						contactPreference: res.meta.contactMeFor                     
                    });                    
                } else {
                    this.setState({ validToken: false });
                }
            })
            .catch(error => {
                this.setState({ validToken: false });
            });
	};
	
	back = () => {
		this.props.history.push('/process/select-interests/' + this.props.match.params["token"]); 
	}
	
	render() {
		return (
            <Fragment>
                <div className="account-wrapper">
				    <StepsHeader></StepsHeader>
                    <section className="checkout pb-5">
				        <div className="container position-relative">				    	    
				    	    <CheckoutSteps onboardStep="[1,2,3,4]" show="4"></CheckoutSteps>
                            <div className="create-profile mx-auto mb-3 position-relative">							
							    <button onClick={() => this.next()} className="border-0 skip d-flex align-items-center ml-auto">Skip this <i className="fe fe-chevron-right ml-2"></i></button>
							    <h3 className="mb-2 text-md-center">Set your preferences</h3>
                                <p className="mb-5 text-md-center text-dark">Let us know how you'd like to be contacted.</p>								
								<h3 className="mt-3 mb-4 text-md-center">Email settings</h3>
                                {/* <p className="mb-5 text-md-center text-dark">Fill in your personal information. They will </p>								 */}
								<div className="row reasons">
								{this.state.emailPreference.map((v, i) => 
										<div className="col-lg-12 text-center mb-3" key={i}>
											<div className="border py-3 pr-4 pl-3 d-inline-block">
												<div className="position-relative custom-control custom-switch text-left">
													<input type="checkbox" checked={this.context.state.inArray(v.id,this.state.emailSettings) ? true : false} onChange={this.handleEmail} className="custom-control-input" id={v.key} value={v.id}/>
													<label className="custom-control-label w-100" for={v.key}>{v.name}</label>
												</div>
											</div>
										</div>
									)}
								</div>
								<h3 className="mt-5 mb-4 text-md-center">Contact me for</h3>
								<div className="row reasons">
								{this.state.contactPreference.map((v, i) => 
										<div className="col-lg-12 text-center mb-3" key={i}>
											<div className={this.context.state.inArray(v.id,this.state.contactSettings) ? "border py-3 pr-4 pl-3 d-inline-block text-left active" : "border py-3 pr-4 pl-3 d-inline-block text-left"}>
												<div className="position-relative custom-control custom-checkbox">
													<input type="checkbox" onChange={this.handleContact}  className="custom-control-input" name="contactPreference" id={v.key} value={v.id}/>
													<label onClick={() => this.whatBrings(v.id)} className="custom-control-label" for={v.key}>
														{v.name}
													</label>
												</div>
											</div>
										</div>
									)}
								</div>	
							</div>
				    	    <hr className="my-5"/>
							<div className="d-flex align-items-center justify-content-between flex-md-row flex-column px-3">
                                <button type="button" onClick={() => this.back()} className="btn back btn-primary border-0">Back</button>	
								<button type="button" onClick={this.handleSubmit} disabled={this.state.loading} className="btn continue btn-primary border-0 mb-md-0 mb-3"><i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : null}></i> {this.state.loading ? `Processing...` : `Continue`}</button>							
							    
							</div>
						</div>		
				    </section>
				</div>	
            </Fragment>
        );
    }
}

Preference.contextType = AppContext;
export default Preference;



// WEBPACK FOOTER //
// ./src/components/general/Preference.js